import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { Switch } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { GET, JSXMap, POST, deleteInArray, errorCatch, updateInArray } from 'fennec-ui';
import PageLayout from '../../components/PageLayout';
var _ = require('lodash');

export default function CommonInfrastructureSubscriptions(props) {
    const dispatch = useDispatch();
    const { auth } = props;

    const [rassilki, setRassilki] = useState()
    const [podpiski, setPodpiski] = useState()

    useEffect(() => {
        GET(auth, `/api/rassilki/list?s-id&w-unsubscribeForbidden=false`,
            ({ data }) => {
                setRassilki(data)
            }, errorCatch)
        GET(auth, `/api/podpiski/list`,
            ({ data }) => {
                setPodpiski(data)
            }, errorCatch)

    }, [])

    const [loading, setLoading] = useState(false);

    return (
        <PageLayout hideBreadcrumbs={true}>
        <div style={{ padding: "15px 10px", backgroundColor: "white", fontSize: "14px", borderRadius:"4px" }}>
            {JSXMap(rassilki, (e, idx) => {
                const podpiska = podpiski?.find(p => p.rassilkaID == e.ID);
                return (
                    <div key={idx} style={{ padding: "10px 0px", width: "100%", /*borderTop: "1px solid #eee",*/ display: "flex", gap: "10px" }}>
                        <div style={{ flex: "1 1 auto" }}>
                            <div style={{ fontWeight: "600" }}>
                                {e.nazvanie}
                            </div>
                            <div>
                                {e.opisanie}
                            </div>
                            {podpiska && <div style={{paddingTop:"5px"}}>
                                <div key={idx+"a"} style={{ padding: "2px 0px", display: "flex", gap: "10px" }}>
                                    <div style={{ flex: "0 0 80px", alignSelf: "center" }}>
                                        <div style={{ fontWeight: "600", fontSize: "12px" }}>
                                            Max
                                        </div>
                                    </div>
                                    <div style={{ flex: "0 0" }}>
                                        <Switch
                                            loading={loading}
                                            size='small'
                                            checked={(podpiska?.max) ? true : false}
                                            onChange={(checked) => {
                                                setLoading(true)
                                                POST(auth, `/api/podpiski/update`, { ...podpiska, max: checked },
                                                    ({ data }) => {
                                                        if (data) {
                                                            setPodpiski(updateInArray(podpiski, data));
                                                            setLoading(false)
                                                        } else {
                                                            setPodpiski(deleteInArray(podpiski, podpiska))
                                                            setLoading(false)
                                                        }
                                                    }, (err) => errorCatch(err, () => setLoading(false))
                                                )
                                            }}
                                        />
                                    </div>
                                </div>
                                <div key={idx+"a"} style={{ padding: "2px 0px", display: "flex", gap: "10px" }}>
                                    <div style={{ flex: "0 0 80px", alignSelf: "center" }}>
                                        <div style={{ fontWeight: "600", fontSize: "12px" }}>
                                            Telegram
                                        </div>
                                    </div>
                                    <div style={{ flex: "0 0" }}>
                                        <Switch
                                            loading={loading}
                                            size='small'
                                            checked={(podpiska?.tg) ? true : false}
                                            onChange={(checked) => {
                                                setLoading(true)
                                                POST(auth, `/api/podpiski/update`, { ...podpiska, tg: checked },
                                                    ({ data }) => {
                                                        if (data) {
                                                            setPodpiski(updateInArray(podpiski, data));
                                                            setLoading(false)
                                                        } else {
                                                            setPodpiski(deleteInArray(podpiski, podpiska))
                                                            setLoading(false)
                                                        }
                                                    }, (err) => errorCatch(err, () => setLoading(false))
                                                )
                                            }}
                                        />
                                    </div>
                                </div>
                                <div key={idx+"b"} style={{ padding: "2px 0px", display: "flex", gap: "10px" }}>
                                    <div style={{ flex: "0 0 80px", alignSelf: "center" }}>
                                        <div style={{ fontWeight: "600", fontSize: "12px" }}>
                                            Vk
                                        </div>
                                    </div>
                                    <div style={{ flex: "0 0" }}>
                                        <Switch
                                            loading={loading}
                                            size='small'
                                            checked={(podpiska?.vk) ? true : false}
                                            onChange={(checked) => {
                                                setLoading(true)
                                                POST(auth, `/api/podpiski/update`, { ...podpiska, vk: checked },
                                                    ({ data }) => {
                                                        if (data) {
                                                            setPodpiski(updateInArray(podpiski, data));
                                                            setLoading(false)
                                                        } else {
                                                            setPodpiski(deleteInArray(podpiski, podpiska))
                                                            setLoading(false)
                                                        }
                                                    }, (err) => errorCatch(err, () => setLoading(false))
                                                )
                                            }}
                                        />
                                    </div>
                                </div>
                                <div key={idx+"c"} style={{ padding: "2px 0px", display: "flex", gap: "10px" }}>
                                    <div style={{ flex: "0 0 80px", alignSelf: "center" }}>
                                        <div style={{ fontWeight: "600", fontSize: "12px" }}>
                                            Email
                                        </div>
                                    </div>
                                    <div style={{ flex: "0 0" }}>
                                        <Switch
                                            loading={loading}
                                            size='small'
                                            checked={(podpiska?.email) ? true : false}
                                            onChange={(checked) => {
                                                setLoading(true)
                                                POST(auth, `/api/podpiski/update`, { ...podpiska, email: checked },
                                                    ({ data }) => {
                                                        if (data) {
                                                            setPodpiski(updateInArray(podpiski, data));
                                                            setLoading(false)
                                                        } else {
                                                            setPodpiski(deleteInArray(podpiski, podpiska))
                                                            setLoading(false)
                                                        }
                                                    }, (err) => errorCatch(err, () => setLoading(false))
                                                )
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>}
                        </div>
                        <div style={{ flex: "0 0" }}>
                            <Switch
                                loading={loading}
                                checkedChildren={<CheckOutlined />}
                                unCheckedChildren={<CloseOutlined />}
                                checked={(podpiska) ? true : false}
                                onChange={(checked) => {
                                    if (!checked) {
                                        setLoading(true)
                                        GET(auth, `/api/podpiski/delete/${podpiska.ID}`,
                                            () => {
                                                setPodpiski(deleteInArray(podpiski, podpiska))
                                                setLoading(false)
                                            }, (err) => errorCatch(err, () => setLoading(false))
                                        );
                                    } else {
                                        setLoading(true)
                                        POST(auth, `/api/podpiski/new`, { rassilkaID: e.ID },
                                            ({ data }) => {
                                                setPodpiski(updateInArray(podpiski, data));
                                                setLoading(false)
                                            }, (err) => errorCatch(err, () => setLoading(false))
                                        )
                                    }
                                }}
                            />
                        </div>
                    </div>
                )
            })}
            </div>
        </PageLayout>
    );
}
